<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="text-h5">Innstillinger</div>
                <v-progress-linear v-if="settingsLoading" indeterminate color="primary"></v-progress-linear>

                <v-row>
                    <v-col>
                        <div v-for="setting in settings" :key="setting.id" style="display: grid">
                            <span class="body-1">{{ settingTranslator(setting.name).name }}</span>
                            <v-text-field v-if="settingTranslator(setting.name).type === 'text'" type="number" :label="settingTranslator(setting.name).label" v-model="setting.updated"></v-text-field>
                            <v-switch v-if="settingTranslator(setting.name).type === 'switch'" :label="settingTranslator(setting.name).label" v-model="setting.updated"></v-switch>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-btn :disabled="!hasChanged" @click="save" color="primary">
                            <span v-if="!isSaving">Lagre</span>
                            <v-progress-circular v-if="isSaving" :size="24" :width="3" indeterminate></v-progress-circular>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider class="my-2"></v-divider>

                <br />

                <div class="headline">Administrasjon</div>

                <div class="d-flex align-center">
                    <!-- <span class="text-body-1">send innloggingsinformasjon e-post til brukere</span> -->
                    <!-- <v-btn @click="showMail" color="primary" class="ml-2" outlined>Velg og send</v-btn> -->
                    <div>Send innloggingsinformasjon e-post til brukere</div>
                    <div class="mx-2"></div>
                    <v-btn @click="showMail" color="primary" fab small>
                        <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                </div>

                <div class="d-flex align-center">
                    <div>Tilgang til infoskjerm</div>
                    <div class="mx-2"></div>
                    <v-btn
                        @click="
                            () => {
                                access.show = true;
                            }
                        "
                        color="primary"
                        fab
                        small
                    >
                        <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                </div>

                <!-- <div class="f-flex">
                    <span class="body-1">last opp dokument</span>
                    <v-btn @click="docUpload.show = true;" color="primary" class="ml-2">Last opp</v-btn>
                </div> -->

                <div>
                    <div></div>
                </div>
            </v-col>
        </v-row>

        <v-dialog v-model="mail.show" persistent fullscreen>
            <v-card>
                <v-card-title class="text-h5 grey lighten-2" primary-title>
                    <div :class="{ 'd-flex': true, 'flex-column': $vuetify.breakpoint.smAndDown }" style="width: 100%">
                        <div>Send innloggingsinformasjon e-post til brukere</div>
                        <v-spacer></v-spacer>
                        <v-btn @click="closeMail" class="align-self-start">Avbryt</v-btn>
                        <div class="ma-1"></div>
                        <v-btn @click="confirmMail" class="align-self-start" :disabled="mail.companiesFilteredChosenUsers.length > 0 || !!mail.searchFilteredChosenUsers" color="primary">Send e-post</v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div>
                                <v-select v-model="document" :items="documents" return-object item-text="displayName" item-value="name" placeholder="velg dokument" label="velg dokument"></v-select>
                                <!-- <v-btn>
                                        <v-icon>mdi-file-document-outline</v-icon>
                                    </v-btn> -->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="elevation-2 ma-1 pa-2">
                                <div class="text-h6">Velg blant registrerte brukere:</div>
                                <!-- <v-divider class="mb-2"></v-divider> -->
                                <div class="d-flex align-center">
                                    <v-select @change="companiesFilteredUsersChanged" v-model="mail.companiesFilteredUsers" :items="mail.companies" item-text="name" label="bedrifter å filtrere på" clearable multiple return-object></v-select>
                                    <v-divider vertical class="mx-2"></v-divider>
                                    <v-text-field @input="searchFilteredUsersInput" v-model="mail.searchFilteredUsers" clearable label="søk"></v-text-field>
                                    <v-divider vertical class="mx-2"></v-divider>
                                    <v-btn @click="choose" color="primary">
                                        <v-icon left>mdi-redo</v-icon>
                                        Velg
                                    </v-btn>
                                </div>
                                <v-data-table v-model="mail.selectedFilteredUsers" :items="mail.filteredUsers" :headers="mail.headers" :loading="mail.usersLoading" show-select :single-select="false" hide-default-footer :items-per-page="-1" :mobile-breakpoint="0"> </v-data-table>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="elevation-2 ma-1 pa-2">
                                <div class="text-h6">Brukere som tilsendes e-post:</div>
                                <!-- <v-divider class="mb-2"></v-divider> -->
                                <div class="d-flex align-center">
                                    <v-select @change="companiesFilteredChosenChanged" v-model="mail.companiesFilteredChosenUsers" :items="mail.companies" item-text="name" label="bedrifter å filtrere på" clearable multiple return-object></v-select>
                                    <v-divider vertical class="mx-2"></v-divider>
                                    <v-text-field @input="searchFilteredChosenInput" v-model="mail.searchFilteredChosenUsers" clearable label="søk"></v-text-field>
                                    <v-divider vertical class="mx-2"></v-divider>
                                    <v-btn @click="remove" color="primary">
                                        <v-icon left>mdi-undo</v-icon>
                                        Fjern
                                    </v-btn>
                                </div>

                                <v-data-table v-model="mail.selectedFilteredChosenUsers" :items="mail.filteredChosenUsers" :headers="mail.headers" show-select hide-default-footer :items-per-page="-1" :mobile-breakpoint="0">
                                    <template v-slot:no-data> Ingen valgte brukere </template>
                                </v-data-table>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="access.show" fullscreen>
            <v-card>
                <v-card-title class="grey lighten-3;">
                    <div class="d-flex" style="width: 100%">
                        <div class="text-h5 font-weight-bold">Tilgang til infoskjerm</div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn
                                @click="
                                    () => {
                                        access.show = false;
                                    }
                                "
                                color="primary"
                                fab
                                small
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text class="text-body-1">
                    <div>
                        <div class="pa-4">
                            <div>
                                <div class="text-h5 black--text">Her kan tilgang til infoskjerm legges til eller fjernes</div>
                                <v-row>
                                    <v-col cols="12" md="9">
                                        <v-text-field v-model="access.new.description" ref="description" label="Beskrivelse til lenken" autofocus @keydown.enter="addInfoscreenAccess" :rules="[(v) => (!!v && v.length > 0) || 'Obligatorisk']"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2">
                                        <v-checkbox v-model="access.new.autoRefresh" label="Auto oppdatering" persistent-hint hint="Infoskjerm oppdaters automatisk"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="1" align-self="center">
                                        <v-btn color="success" @click="addInfoscreenAccess" :class="{ 'float-right': $vuetify.breakpoint.smAndUp }"> legg til </v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <div class="d-flex align-center">
                                    <v-text-field v-model="access.new.description" ref="description" label="Beskrivelse til lenken" autofocus @keydown.enter="addInfoscreenAccess" :rules="[v => !!v && v.length > 0 || 'Obligatorisk']"></v-text-field>
                                    <div class="mx-2"></div>
                                    <v-checkbox v-model="access.new.autoRefresh" label="Auto oppdatering" persistent-hint hint="Infoskjerm oppdaters automatisk"></v-checkbox>
                                    <v-btn color="success" @click="addInfoscreenAccess">
                                        legg til
                                    </v-btn>
                                </div> -->
                            </div>
                        </div>
                        <div class="ma-2"></div>
                        <div></div>
                        <v-data-table :items="access.links" :headers="access.headers" :mobile-breakpoint="-1" disable-pagination hide-default-footer>
                            <template v-slot:[`item.createdAt`]="{ item }">
                                <div>{{ moment.unix(item.createdAt) }}</div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="d-flex">
                                    <v-btn text fab small color="error" @click="deleteInfoscreenAccess(item)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-btn text fab small color="success" @click="navigateToInfoscreen(item)">
                                        <v-icon>mdi-cog</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:no-data> Ingen tilganger tilgjengelig </template>
                        </v-data-table>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as moment from "moment";
import { v4 as uuidv4 } from "uuid";
export default {
    data() {
        return {
            settings: [],
            settingsLoading: false,
            isSaving: false,
            mail: {
                show: false,

                companies: [],

                users: [],
                usersLoading: false,
                filteredUsers: [],
                selectedFilteredUsers: [],

                chosenUsers: [],
                filteredChosenUsers: [],
                selectedFilteredChosenUsers: [],

                searchFilteredUsers: "",
                searchFilteredChosenUsers: "",
                companiesFilteredUsers: [],
                companiesFilteredChosenUsers: [],

                headers: [
                    { text: "Navn", value: "name", sortable: true },
                    { text: "Brukernavn", value: "username", sortable: true },
                ],
            },
            document: undefined,
            access: {
                show: false,
                new: {
                    description: undefined,
                    autoRefresh: false,
                },
                headers: [
                    { text: "Beskrivelse", value: "description" },
                    { text: "Lenke", value: "link" },
                    { text: "Opprettet", value: "createdAt" },
                    { text: "Handlinger", value: "actions" },
                ],
                links: [],
            },
            moment: moment,
        };
    },
    methods: {
        showMail: function () {
            this.mail.usersLoading = true;
            // populate users:
            this.axios
                .get(`/user`)
                .then((response) => {
                    if (response.data.success) {
                        let users = response.data.data;

                        this.mail.users = users;
                        this.mail.filteredUsers = users;
                    }
                })
                .finally(() => {
                    this.mail.usersLoading = false;
                });

            // populate companies:
            this.axios.get(`/company`).then((response) => {
                if (response.data.success) {
                    this.mail.companies = response.data.data;
                }
            });

            this.mail.show = true;
        },
        closeMail: function () {
            this.mail.companies = [];

            this.mail.users = [];
            this.mail.filteredUsers = [];
            this.mail.selectedFilteredUsers = [];

            this.mail.chosenUsers = [];
            this.mail.filteredChosenUsers = [];
            this.mail.selectedFilteredChosenUsers = [];

            this.mail.searchFilteredUsers = "";
            this.mail.searchFilteredChosenUsers = "";
            this.mail.companiesFilteredUsers = [];
            this.mail.companiesFilteredChosenUsers = [];

            this.mail.show = false;
        },
        companiesFilteredUsersChanged: function () {
            let filtered = this.mail.users.filter((u) => {
                if (this.mail.companiesFilteredUsers.length == 0) return true;

                return this.mail.companiesFilteredUsers.map((c) => c.id).includes(u.company ? u.company.id : null);
            });

            if (this.mail.searchFilteredUsers) filtered = filtered.filter((u) => u.name.toLowerCase().includes(this.mail.searchFilteredUsers.toLowerCase()));

            this.mail.filteredUsers = filtered;
            this.mail.selectedFilteredUsers = this.mail.selectedFilteredUsers.filter((u) => this.mail.filteredUsers.includes(u));
        },
        searchFilteredUsersInput: function () {
            this.companiesFilteredUsersChanged();
        },
        companiesFilteredChosenChanged: function () {
            let filtered = this.mail.chosenUsers.filter((u) => {
                if (this.mail.companiesFilteredChosenUsers.length == 0) return true;

                return this.mail.companiesFilteredChosenUsers.map((c) => c.id).includes(u.company ? u.company.id : null);
            });

            if (this.mail.searchFilteredChosenUsers) filtered = filtered.filter((u) => u.name.toLowerCase().includes(this.mail.searchFilteredChosenUsers.toLowerCase()));

            this.mail.filteredChosenUsers = filtered;
        },
        searchFilteredChosenInput: function () {
            this.companiesFilteredChosenChanged();
        },
        choose: function () {
            this.mail.chosenUsers = this.mail.chosenUsers.concat(this.mail.selectedFilteredUsers.filter((u) => !this.mail.chosenUsers.includes(u)));

            this.mail.selectedFilteredUsers.splice(0, this.mail.selectedFilteredUsers.length);

            this.companiesFilteredChosenChanged();
        },
        remove: function () {
            this.mail.chosenUsers = this.mail.chosenUsers.filter((u) => !this.mail.selectedFilteredChosenUsers.includes(u));

            this.mail.selectedFilteredChosenUsers.splice(0, this.mail.selectedFilteredChosenUsers.length);

            this.companiesFilteredChosenChanged();
        },
        confirmMail: function () {
            let numberOfEmails = this.mail.chosenUsers.length;

            if (!this.document) {
                this.$store.commit("snackbar", {
                    text: `Velg dokument.`,
                    color: "error",
                    show: true,
                });
                return;
            }

            if (numberOfEmails == 0) {
                this.$store.commit("snackbar", {
                    text: `Velg minst en bruker.`,
                    color: "error",
                    show: true,
                });
                return;
            }

            this.axios
                .post(`/user/infomessage`, {
                    userIds: this.mail.chosenUsers.map((u) => u.id),
                    file: this.document,
                })
                .then((response) => {
                    if (response.data.success) {
                        this.$store.commit("snackbar", {
                            text: `${numberOfEmails} e-postmeldinger sendt.`,
                            color: "success",
                            show: true,
                        });
                    } else {
                        this.$store.commit("snackbar", {
                            text: `Feil oppstått - ingen e-postmeldinger sendt.`,
                            color: "error",
                            show: true,
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Feil oppstått - ingen e-postmeldinger sendt.`,
                        color: "error",
                        show: true,
                    });
                });

            this.closeMail();
        },
        settingTranslator: function (settingName) {
            var settingConfig = {};
            switch (settingName) {
                case "exittime":
                    settingConfig.name = "utgangstidsforlengelse";
                    settingConfig.type = "text";
                    settingConfig.label ="periode i timer";
                    return settingConfig;
                case "entrytime":
                    settingConfig.name = "inngangstidsforlengelse";
                    settingConfig.type = "text";
                    settingConfig.label ="periode i timer";
                    return settingConfig;
                case "defaultaccesscode":
                    settingConfig.name = "auto ringetilgang";
                    settingConfig.type = "switch";
                    settingConfig.label ="Automatisk legge til en 'alltid'-ringetilgang til nye brukere";
                    return settingConfig;
                case "unlimitedreuse":
                    settingConfig.name = "ubegrenset bruk av SMS kode";
                    settingConfig.type = "switch";
                    settingConfig.label ="SMS koder kan brukes ubegrenset innenfor leveransens tidsperiode";
                    return settingConfig;
            }
        },
        save: function () {
            this.isSaving = true;

            let persistedSettings = [];
            this.settings.forEach((s) => {
                let setting = {};
                Object.assign(setting, s);
                setting.setting = setting.updated;
                delete setting.updated;
                persistedSettings.push(setting);
            });

            this.axios
                .post(`/setting`, persistedSettings)
                .then((response) => {
                    if (response.data.success) {
                        this.settings.forEach((s) => {
                            s.setting = s.updated;
                        });
                        // console.log("OK");
                    }
                })
                .catch(() => {
                    // console.log(err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        async loadInfoscreenAccess() {
            try {
                let response = await this.axios.get("/infoscreen/links");

                this.access.links = response.data.data;
            } catch (error) {
                this.$store.dispatch("snackbar", {
                    show: true,
                    text: "Feil ved henting av infoscreen lenker.",
                    color: "error",
                });
            }
        },
        async addInfoscreenAccess() {
            if (!this.access.new.description || this.access.new.description.trim().length === 0) {
                this.access.new.description = undefined;
                this.$store.dispatch("snackbar", {
                    show: true,
                    text: "Beskrivelse mangler.",
                    color: "error",
                });
                return;
            }

            let uuid = uuidv4();

            let newLink = {
                description: this.access.new.description,
                link: `${window.origin}/#/infoscreen/${this.$store.getters.project}/${uuid}/${this.access.new.autoRefresh}`,
                uuid: uuid,
                createdBy_id: this.$store.getters.userId,
            };

            this.access.new.description = undefined;

            try {
                let response = await this.axios.post("/infoscreen/links", { link: newLink });
                this.access.links.push(response.data);
            } catch {
                // console.log(err);
                this.$store.commit("snackbar", {
                    text: `Henting av tilganger feilet.`,
                    color: "error",
                    show: true,
                });
            }
        },
        async navigateToInfoscreen(infoscreen) {
            window.location = infoscreen.link;
        },
        async deleteInfoscreenAccess(infoscreen) {
            try {
                await this.axios.delete(`/infoscreen/${infoscreen.uuid}`);
                let index = this.access.links.findIndex((i) => i.uuid == infoscreen.uuid);
                if (index >= 0) {
                    this.access.links.splice(index, 1);
                }
            } catch {
                // console.log(err);
                this.$store.commit("snackbar", {
                    text: `Fjerning av tilgang feilet.`,
                    color: "error",
                    show: true,
                });
            }
        },
    },
    computed: {
        hasChanged: function () {
            return this.settings.some((s) => s.setting != s.updated);
        },
        documents() {
            return this.$store.getters.filesByType("documents");
        },
    },
    watch: {
        "access.show": function (show) {
            if (show) {
                this.loadInfoscreenAccess();
            }
        },
    },
    mounted() {
        this.settingsLoading = true;

        this.axios
            .get(`/setting`)
            .then((response) => {
                if (response.data.success) {
                    var settings = response.data.data;

                    settings.forEach((setting) => {
                        let dbSetting = {};
                        dbSetting.id = setting.id;
                        dbSetting.name = setting.name;
                        dbSetting.setting = setting.setting;
                        dbSetting.updated = setting.setting;

                        if (setting.name == "defaultaccesscode" || setting.name == "unlimitedreuse") {
                            dbSetting.setting = Number(setting.setting);
                            dbSetting.updated = dbSetting.setting;
                        }

                        this.settings.push(dbSetting);
                    });
                }
            })
            .catch(() => {
                this.settingsLoading = false;
            })
            .then(() => {
                this.settingsLoading = false;
            });
        // .finally(() => {
        //     this.settingsLoading = false;
        // });

        this.$store.dispatch("listFiles", "documents").then((docs) => {
            docs.forEach((d) => {
                let displayName = /.*\/(.*)/.exec(d.name)[1];
                // d.displayName = displayName;
                this.$set(d, "displayName", displayName);

                this.$store.dispatch("addFile", d);
            });
        });
    },
    beforeRouteEnter(to, from, next) {
        next((vue) => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
.dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 100px;
    width: 100%;
    position: relative;
    cursor: pointer;

    &:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    p {
        font-size: 1.2em;
        text-align: center;
        text-justify: center;
        padding: 0 0;
    }
}
.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 90%;
    height: 100px;
    position: absolute;
    cursor: pointer;
    z-index: 10;
}
</style>
